import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import CategorySlider from './components/CategorySlider';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';

const siteUrl = (import.meta.env.VITE_SITE_URL || 'https://yoybuy.cyou').replace(/\/$/, '');

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'YOYbuy Sheet',
  url: siteUrl,
  description: 'YOYbuy Sheet — ваш инструмент для умного шоппинга из Китая. Таблицы заказов, сравнение агентов, категории товаров: обувь, худи, футболки, куртки, сумки, аксессуары и многое другое.',
  inLanguage: 'ru',
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'YOYbuy Sheet',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67a09e300463e31c534fce7fbe7473f7.jpeg',
  description: 'Инструмент для организации заказов из Китая через электронные таблицы.',
  sameAs: ['https://kaspreadsheet.com'],
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySlider />
        <CategoryGrid />
        <AboutSection />
        <ArticlesSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}